/**
 * An employee's assignment to an order, as the v2 order assignment API returns it.
 */
export interface OrderEmployeeAssignment {
  employee: OrderAssignmentEmployee;
  type: OrderEmployeeAssignmentType;
  teamLeader: boolean;
}

/**
 * The assigned employee. `id` is the employee's uuid, not the numeric database id.
 */
export interface OrderAssignmentEmployee {
  id: string;
  employeeNumber: number;
  firstName: string;
  lastName: string;
}

export enum OrderEmployeeAssignmentType {
  EMPLOYEE = "EMPLOYEE",
  SUPERVISOR = "SUPERVISOR"
}

/**
 * The body to assign an employee to an order, or to change the employee's assignment.
 */
export interface OrderAssignmentRequest {
  type: OrderEmployeeAssignmentType;
  teamLeader: boolean;
}
